var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "details",
    {
      staticClass: "dropdown",
      class: _vm.bemFacets,
      attrs: { open: _vm.isOpen },
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c(
        "summary",
        {
          staticClass: "dropdown--summary",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.toggle($event)
            }
          }
        },
        [
          _c("div", { staticClass: "dropdown--label" }, [
            _vm._v("\n            " + _vm._s(_vm.label) + "\n            "),
            _c(
              "div",
              { staticClass: "dropdown--icon" },
              [_c("ui-icon", _vm._b({}, "ui-icon", _vm.icon, false))],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "dropdown--collection-wrapper" }, [
        _c(
          "ul",
          { staticClass: "dropdown--collection u-reset" },
          _vm._l(_vm.items, function(item, index) {
            return _c("li", { key: index, staticClass: "dropdown--item" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown--link u-reset",
                  class: _vm.getLinkFacets(item.facets),
                  attrs: {
                    target: item.external ? "_blank" : "_self",
                    rel: item.external ? "noopener" : null,
                    href: item.path
                  },
                  on: { click: _vm.close }
                },
                [
                  _c("span", { staticClass: "dropdown--link-text" }, [
                    _vm._v(_vm._s(item.label))
                  ]),
                  _vm._v(" "),
                  item.icon
                    ? _c(
                        "div",
                        { staticClass: "dropdown--link-icon" },
                        [
                          _c("ui-icon", _vm._b({}, "ui-icon", item.icon, false))
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            ])
          }),
          0
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dfcae738", { render: render, staticRenderFns: staticRenderFns })
  }
}